<!-- src/comonets/quote.vue -->
<template src="./quote.html">
</template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

import * as XLSX from "xlsx"

export default {
  name: "Quote",
  data() {
    return {
      active_voice: '',
      base_code: null,
      bases: [],
      bracket_measure_units: [],
      calculation_formula: null,
      calculation_formulas: [],
      currency: null,
      currencies: [],
      currentPage: 1,
      customer: null,
      customers: [],
      depth_obj: null,
      end_date: '',
      equipment_size: null,
      equipment_sizes: [],
      free_time: 0,
      goods_kinds: [],
      isStaff: false,
      lenght_obj: null,
      location_code1: null,
      location_code2: null,
      locations: [],
      lower_end_bracket: null,
      max_peso_ingombro: null,
      measure_units: [],
      minimal_amout: null,
      page: 1,
      packaging_kind: null,
      passive_voice: '',
      perPage: 10,
      price_list_names: [],
      prices_list_rows: [],
      prices_list_columns: [
        { label: "Nome riga", key: 'price_list_name', sortable: false, tdStyle: { width: '10%' } },
        { label: "Tratte", key: 'locations', sortable: false, tdStyle: { width: '10%' } },
        { label: "Valuta", key: 'currency', sortable: false, tdStyle: { width: '10%' } },
        { label: "Voce", key: 'voice_name', sortable: false, tdStyle: { width: '10%' } },        
        { label: "Formula", key: 'calculation_formula', sortable: false, tdStyle: { width: '10%' } },
        { label: "Importo unitario", key: 'unit_amount', sortable: false, tdStyle: { width: '10%' } },
        { label: "Importo", key: 'amount', sortable: false, tdStyle: { width: '10%' } },
      ],
      quantity: null,
      rows: 50,
      packaging_kinds: [],
      selectedAction: null,
      selectedBase: null,
      selectedBracketMeasureUnit: null,
      selectedCalculationFormula: null,
      selectedCurrency: null,
      selectedCustomer: null,
      selectedEquipmentSize: null,
      selectedGoodsKind: null,
      selectedLocationId1: null,
      selectedLocationId2: null,
      selectedMeasureUnit: null,
      selectedName: null, 
      selectedPackagingKind: null,
      selectedPriceListName: '',
      selectedUM: null,
      showAlertMandatoryLocations: false,
      showAlertMandatoryNotFound: false,
      showAlertMandatoryQty: false,
      showAlertPesoIncoerente: false,
      start_date: '',
      unit_amount: null,
      unit_cost: null,
      upper_end_bracket: null,
      voice_name: '',
      volume: null,
      weight: null,
      width_obj: null,
    }
  },
  async mounted() {

    if(localStorage.getItem("UserAclRoleId") < 3) {

      this.isStaff = true
      this.loadNames()
    }

    const user_id = localStorage.getItem("User_id")
    const url_role = API_URL + "login/UsersDetail/"+user_id+"/"
    const headers = {
      'User-ID': localStorage.getItem('User_id'),
      'token': localStorage.getItem('Token'),
    }
    const response_role = await axios.get(url_role, {headers: headers})

    if(localStorage.getItem("UserAclRoleId") > 2) {

      const url_customer = API_URL + "customers/CustomersDetailByUserid/"+localStorage.getItem("User_id")+"/"
      const response_customer = await axios.get(url_customer, {headers: headers})
      this.customer = response_customer.data.id
    }
    else {

      this.customer = 0
    }

    this.loadBases()  
    this.loadBracketMeasuresUnit()
    this.loadCustomersList()
    this.loadCurrencies()
    this.loadEquipmentSizes()
    this.loadFormulas()
    this.loadGoodsKinds()
    this.loadLocations()
    this.loadMeasureUnits()
    this.loadNames()
    this.loadPackagingKinds()
    this.loadPricesListVoices()    
    //this.loadQuotes()
  },
  methods: {
    async calculateQuote() {

      this.showAlertMandatoryQty = false
      this.showAlertMandatoryNotFound = false

      const pesoFields = [this.max_peso_ingombro, this.weight, this.volume];
      const filledCount = pesoFields.filter(field => field != null && field !== '' && field !== undefined).length;

      if (filledCount > 0 && filledCount < 3) { 
  
        this.showAlertPesoIncoerente = true
        return
      }

      if(!this.quantity) {

        this.showAlertMandatoryQty = true
        return
      }
    
      let finalQuantity = parseFloat(this.quantity)
      
      if(this.free_time) {

        finalQuantity = Math.max(0, finalQuantity - parseFloat(this.free_time))
      }

      let taxableWeight = null

      if(this.weight && this.max_peso_ingombro) {

        const volumetricWeight = parseFloat(this.weight) * parseFloat(this.max_peso_ingombro)
        taxableWeight = Math.max(parseFloat(this.volume || 0), volumetricWeight)
        finalQuantity = taxableWeight; 
      }

      const url = API_URL + "price_list/CalculateAmounts/"

      const params = {
        active_voice: this.active_voice || null,
        base_id: this.selectedBase || null,
        bracket_measure_unit_id: this.selectedBracketMeasureUnit || null,
        calculation_formula_id: this.selectedCalculationFormula || null,
        currency_id: this.selectedCurrency || null,
        customer_id: this.selectedCustomer || null,
        end_date: this.end_date || null,
        equipment_size: this.selectedEquipmentSize || null,
        free_time: this.free_time || 0,
        good_kind_id: this.selectedGoodsKind || null,
        location_code1_id: this.selectedLocationId1 || null,
        location_code2_id: this.selectedLocationId2 || null,
        lower_end_bracket: this.lower_end_bracket || null,
        measure_unit_id: this.selectedUM || null,
        packaging_kind_id: this.selectedPackagingKind || null,
        price_list_name: this.selectedPriceListName || null,
        quantity: finalQuantity, 
        start_date: this.start_date || null,
        taxable_weight: taxableWeight,
        unit_amount: this.unit_amount || null,
        unit_cost: this.unit_cost || null,
        upper_end_bracket: this.upper_end_bracket || null,
        voice_name: this.voice_name || null,
      }

      try {
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }

        const response = await axios.get(url, { params: params, headers: headers })
        
        let resultRows = response.data.map(row => ({
          price_list_name: row.price_list_name,
          currency: row.currency,
          locations: row.locations,
          voice_name: row.voice_name,
          unit_amount: row.unit_amount,
          calculation_formula: row.formula,
          amount: row.amount.toFixed(2),
        }))

        this.prices_list_rows = this.prices_list_rows.concat(resultRows)

        if(!resultRows.length) {
          
          this.showAlertMandatoryNotFound = true
        }
      } 
      catch (error) {
      
        console.debug("Error calculating quote:", error)
      }
    },    
    calculateVolumeFromDimensions() {
    
      if (this.lenght_obj && this.width_obj && this.depth_obj) {
    
        const volumeCm3 = parseFloat(this.lenght_obj) * parseFloat(this.width_obj) * parseFloat(this.depth_obj)
        this.volume = (volumeCm3 / 1000000).toFixed(4)
      }
    },
    clearFilter() {

      this.active_voice = ""
      this.end_date = ''
      this.equipment_size = null
      this.free_time = 0
      this.lower_end_bracket = ""
      this.max_peso_ingombro = null
      this.passive_voice = ""
      this.quantity = null
      this.selectedBracketMeasureUnit = null
      this.selectedCalculationFormula = null
      this.selectedCurrency = null
      this.selectedCustomer = null
      this.selectedEquipmentSize = null
      this.selectedGoodsKind = null
      this.selectedLocationId1 = null
      this.selectedLocationId2 = null
      this.selectedPackagingKind = null
      this.selectedPriceListName = null
      this.selectedUM = null
      this.start_date = ''
      this.upper_end_bracket = ""
      this.volume = null
      this.weight = null
      this.depth_obj = null
      this.lenght_obj = null
      this.width_obj = null
    },
    clearParams() {

      console.debug("clearParams()")
      this.depth_obj = null
      this.lenght_obj = null
      this.width_obj = null
    },
    clearQuote() {

      this.prices_list_rows = []
    },
    async exportToExcel() {

      try {

        const worksheet = XLSX.utils.json_to_sheet(this.prices_list_rows)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, "Preventivo")

        XLSX.writeFile(workbook, "Preventivo.xlsx")
      } 
      catch (error) {

        console.error("Error exporting to Excel:", error)
      }
    },
    async loadBases() {

      try {

        const url = API_URL+"price_list/BasesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.bases = response.data
      }
      catch(error) {

        console.debug("Error loading bases list:", error)
      }
    },
    async loadBracketMeasuresUnit() {

      try {

        const url = API_URL+"various/BracketMeasureUnitsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.bracket_measure_units = response.data
      }
      catch(error) {

        console.debug("Error loading measure units list:", error)
      }
    },
    async loadEquipmentSizes() {

      try {

        const url = API_URL+"various/EquipmentSizesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.equipment_sizes = response.data
      }
      catch(error) {

        console.debug("Error loading equipment sizes list:", error)
      }      
    },
    async loadFormulas() {

      try {

        const url = API_URL+"price_list/CalculationFormulasList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.calculation_formulas = response.data
      }
      catch(error) {

        console.debug("Error loading calculation formulas list:", error)
      }
    },
    async loadCustomersList() {

      try {

        const url = API_URL+"customers/CustomersList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.customers = response.data
      }
      catch(error) {

        console.debug("Error loading customers list:", error)
      }
    },
    async loadCurrencies() {

      try {

        const url = API_URL+"price_list/CurrenciesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.currencies = response.data
      }
      catch(error) {

        console.debug("Error loading currencies list:", error)
      }
    },
    async loadGoodsKinds() {

      try {

        const url = API_URL+"various/GoodsKindsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.goods_kinds = response.data
      }
      catch(error) {

        console.debug("Error loading currencies list:", error)
      }      
    },
    async loadLocations() {

      try {

        const url = API_URL+"geographic/LocationsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.locations = response.data.map(location => ({
          value: location.location,
          text: location.location,          
        }))
      }
      catch(error) {

        console.debug("Error loading locations list:", error)
      }      
    },
    async loadMeasureUnits() {
      
      try {

        const url = API_URL + "various/MeasureUnitsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.measure_units = response.data
      } 
      catch (error) {
      
        console.debug("Error loading measure units list:", error)
      }
    },
    async loadNames() {

      try {

        const url = API_URL+"price_list/NamesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.customers = response.data.map(customer => ({
          value: customer.id,
          text: customer.company,          
        }))
        this.customers.unshift({value: 0, text: ""})
      }
      catch(error) {

        console.debug("Error loading locations list:", error)
      }      
    },
    async loadPackagingKinds() {

      try {

        const url = API_URL+"various/PackagingsKindsList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.packaging_kinds = response.data
      }
      catch(error) {

        console.debug("Error loading packaging kinds:", error)
      }      
    },    
    async loadPricesListVoices() {

      try {

        const url = API_URL + "price_list/PriceListDistinct/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.price_list_names = response.data
      }
      catch(error) {

        console.debug("Error loading prices_list:", error)
      }      
    },    
    async loadQuotes() {

      try {

        const url = API_URL + "price_list/QuotesList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.get(url, {headers: headers})
        this.price_list_names = response.data
      } 
      catch (error) {
      
        console.debug("Error loading pricelist names list:", error)
      }
    },
    onPageChange(newValue) {
    
      this.currentPage = page;
      this.updateTableData();
    },
    rotateDate(date) {

      if(date) {

        return date.slice(6,4)+"-"+date.slice(3,2)+"-"+date.slice(0,2)
      }

      return null
    },
    async updatePriceList() {

      if(this.selectedCustomer) {

        const url = API_URL+"price_list/GetPricesListByCustomer/"+this.selectedCustomer+"/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }          
        const response = await axios.get(url, {headers: headers})

        try {
        
          this.price_list_names = response.data
        }
        catch (error) {
        
          ("Error getting prices list of customer:", error)
        }  
      }
      else {

        this.loadQuotes()
      }
    }
  },
}

</script>